import { ExportGapFilterType } from "@app/exports/enumerations";
import { FC, useContext } from "react";
import { VolumeReportsContext } from "./VolumeReportsContext";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";
import { QESRadioGroup } from "@app/shared/qes-standards/forms/RadioGroup";

export const VolumeReportsServiceAreaFilter: FC = () => {
  const wizardContext = useContext(VolumeReportsContext);

  return (
    <section>
      <h2 className="header-m">Service Area Filter</h2>
      <p className="mb-1">Please select the service area to include:</p>
      <p className="mb-1">Reports will include zip codes based on the Primary Counties selected in the Service Area. The Primary County designation is reflective of the zip code population centroid assignment.</p>

      <QESRadioGroup
        groupLabel="Include"
        groupContainerClass="mt-4"
      >
        <QESRadioButton
          label="All Areas"
          name="service-area-gaps"
          testId="volume-reports__service-area-gaps-filters--all"
          value={ExportGapFilterType.All}
          checked={wizardContext.countiesGapsFilter === ExportGapFilterType.All}
          onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
        />
        <QESRadioButton
          label="Areas with Gaps"
          name="service-area-gaps"
          testId="volume-reports__service-area-gaps-filters--gaps"
          value={ExportGapFilterType.Gaps}
          checked={wizardContext.countiesGapsFilter === ExportGapFilterType.Gaps}
          onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
        />
        <QESRadioButton
          label="Areas with Exceptions"
          name="service-area-gaps"
          testId="volume-reports__service-area-gaps-filters--exceptions"
          value={ExportGapFilterType.Exceptions}
          checked={wizardContext.countiesGapsFilter === ExportGapFilterType.Exceptions}
          onChange={(e) => wizardContext.setCountiesGapsFilter(e.target.value as ExportGapFilterType)}
        />
      </QESRadioGroup>
    </section>
  );
}
